<template>
  <div>
    <section id="sectionId" class="d-flex body-content pt-0 resource_page_main">
      <div class="container-fluid">
        <div class="resource-custom-wrap">
          <div class="sidebar active" style="background: #fff">
            <!-- flter back mob -->
            <span
              class="d-flex d-md-none res-filter-mob-back align-items-center"
              v-on:click="mob_resFilter()"
            >
              <svg
                data-v-49afa8f2=""
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                fill="#242432"
                width="24px"
                height="24px"
                viewBox="0 0 31.494 31.494"
                xml:space="preserve"
              >
                <path
                  data-v-49afa8f2=""
                  d="M10.273,5.009c0.444-0.444,1.143-0.444,1.587,0c0.429,0.429,0.429,1.143,0,1.571l-8.047,8.047h26.554 c0.619,0,1.127,0.492,1.127,1.111c0,0.619-0.508,1.127-1.127,1.127H3.813l8.047,8.032c0.429,0.444,0.429,1.159,0,1.587 c-0.444,0.444-1.143,0.444-1.587,0l-9.952-9.952c-0.429-0.429-0.429-1.143,0-1.571L10.273,5.009z"
                  style="fill: rgb(30, 32, 29)"
                ></path>
                <g data-v-49afa8f2=""></g>
                <g data-v-49afa8f2=""></g>
                <g data-v-49afa8f2=""></g>
                <g data-v-49afa8f2=""></g>
                <g data-v-49afa8f2=""></g>
                <g data-v-49afa8f2=""></g>
                <g data-v-49afa8f2=""></g>
                <g data-v-49afa8f2=""></g>
                <g data-v-49afa8f2=""></g>
                <g data-v-49afa8f2=""></g>
                <g data-v-49afa8f2=""></g>
                <g data-v-49afa8f2=""></g>
                <g data-v-49afa8f2=""></g>
                <g data-v-49afa8f2=""></g>
                <g data-v-49afa8f2=""></g>
              </svg>
              <label class="mb-0 ml-2">Back</label>
            </span>
            <!-- flter back -->
            <div
              id="left-section"
              class="resources-left-filter-hld custom-radios"
            ></div>
            <div class="category-wrapper">
              <div class="select-box mt-3">
                <h6
                  data-toggle="collapse"
                  href="#Category"
                  aria-expanded="true"
                >
                  {{ $t("resource.category") }}
                </h6>
                <div class="language-box in collapse show" id="Category">
                  <div
                    class="checkbox-hld"
                    v-for="category in categoryList"
                    v-bind:key="category.Id"
                  >
                    <input
                      v-if="notMappedCategories.includes(category.Id)"
                      type="radio"
                      :id="category.Id"
                      name="radio-category"
                      :value="category.Name"
                      v-model="filterByCategory"
                      :data-tag="
                        'resources/' + 'categoryFilter' + '/' + category.Name
                      "
                      v-on:click="onClickHandler"
                    />
                    <label
                      v-if="notMappedCategories.includes(category.Id)"
                      :for="category.Id"
                    >
                      {{ category.Name }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="select-box mt-3">
                <h6 data-toggle="collapse" href="#Types" aria-expanded="true">
                  {{ $t("resource.types") }}
                </h6>
                <div class="language-box in collapse show" id="Types">
                  <div
                    class="checkbox-hld"
                    v-for="type in resourceTypeList"
                    v-bind:key="type.Id"
                  >
                    <input
                      type="radio"
                      :id="type.Id"
                      name="radio-types"
                      :value="type.Name"
                      v-model="filterByType"
                      :data-tag="'resources/' + 'typeFilter' + '/' + type.Name"
                      v-on:click="onClickHandler"
                    />
                    <label :for="type.Id">
                      {{ type.DisplayName }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- mobile filter apply -->
            <div class="d-block d-md-none" v-on:click="mob_resFilter()">
              <button class="btn res_btnapply">Apply</button>
            </div>
            <!-- mobile filter apply -->
          </div>
          <div class="full-width px-5">
            <div class="content-header-part">
              <div
                class="d-flex justify-content-between align-items-center flex-sm-row flex-md-row flex-column mb-3"
              >
                <div class="d-flex res_top align-items-center">
                  <h1 class="page-head text-uppercase mb-0 mt-md-3">
                    <span id="headerText"></span>
                  </h1>
                  <div class="d-flex align-items-center mob-row-reverse">
                    <button
                      class="resources-filter-btn mt-md-2 ml-md-3"
                      v-on:click="leftPanelOpen()"
                      v-if="hideFilters"
                      :data-tag="'resources/' + 'FilterBtn'"
                      @click="onClickHandler"
                    >
                      Filter
                    </button>
                    <!-- mobile search button -->
                    <div class="d-block d-md-none">
                      <button
                        class="mob_search_button"
                        v-on:click="mob_reslist_search()"
                      >
                        <img
                          src="../assets/Images/icons/search-black.svg"
                          alt="e2m"
                          width="20px"
                        />
                      </button>
                    </div>
                    <!-- mobile search button end -->
                  </div>
                </div>
                <div class="search-main ml-auto pr-md-0" v-if="hideFilters">
                  <div
                    class="search-check position-relative mb-0 mt-4"
                    id="mob_res_search"
                  >
                    <div
                      class="search-resources-box"
                      style="position: relative"
                    >
                      <input
                        type="text"
                        class="form-control search-project"
                        placeholder="Search Files"
                        v-model="searchVal"
                      />
                      <div class="reset-search-btn">
                        <p @click="searchVal = ''">
                          Clear<v-icon dark small color="#8a8a8a"
                            >mdi-close</v-icon
                          >
                        </p>
                      </div>
                    </div>
                    <a href="javascript:void(0);"> &nbsp; </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="content-lower-part">
              <div
                class="top-fixed-sorting-wrapper"
                v-if="filteredResourcePinList.length !== 0"
              >
                <!----slider 15.02.21------>
                <div class="slider-area position-relative">
                  <div class="sorting-carousel">
                    <carousel
                      v-if="filteredResourcePinList.length !== 0"
                      :items="3"
                      :loop="false"
                      :autoplay="false"
                      :autoplayTimeout="8000"
                      :mouseDrag="true"
                      :margin="10"
                      :dots="false"
                      :nav="false"
                      responsive-class:true
                      :responsive="{
                        0: { items: 1.5 },
                        600: { items: 2 },
                        800: { items: 2 },
                        1200: { items: 3 },
                      }"
                    >
                      <!-----single item start--->

                      <div
                        class="item custom-filter-right"
                        v-for="resource1 in filteredResourcePinList"
                        v-bind:key="resource1.Id"
                      >
                        <div
                          class="masonry-grid-item mb-0"
                          v-if="resource1.IsPinned == true"
                          v-on:click="openResourceModal(resource1)"
                          :data-tag="
                            'resources/' +
                            'viewed' +
                            '/' +
                            resource1.ResourceName
                          "
                          @click="onClickHandler"
                        >
                          <div class="re-wrapperd-flex flex-column">
                            <figure
                              class="cursor-pointer"
                              v-if="resource1.ResourceType == 'code'"
                            >
                              <div class="shimmer-effect">
                                <photo class="shine"></photo>
                              </div>
                              <div class="resource-pin">
                                <span
                                  ><img src="../assets/Player/images/unpin.svg"
                                /></span>
                              </div>
                              <div
                                v-html="resource1.EmbedCode"
                                v-on:load="stopShimmer()"
                              ></div>
                            </figure>
                            <figure
                              class="cursor-pointer"
                              v-if="
                                resource1.ResourceType == 'pdf' &&
                                resource1.CoverImageURL == ''
                              "
                            >
                              <div class="shimmer-effect">
                                <photo class="shine"></photo>
                              </div>
                              <div class="resource-pin">
                                <span
                                  ><img src="../assets/Player/images/unpin.svg"
                                /></span>
                              </div>
                              <img
                                alt="Detail1"
                                src="../assets/Images/pdf-file.jpg"
                                v-on:load="stopShimmer()"
                              />
                            </figure>
                            <figure
                              class="cursor-pointer"
                              v-if="
                                resource1.ResourceType == 'video' &&
                                (resource1.CoverImageURL == null ||
                                  resource1.CoverImageURL == '')
                              "
                            >
                              <div class="shimmer-effect">
                                <photo class="shine"></photo>
                              </div>
                              <div class="resource-pin">
                                <span
                                  ><img src="../assets/Player/images/unpin.svg"
                                /></span>
                              </div>
                              <img
                                alt="Detail1"
                                src="../assets/Images/video-temp.jpg"
                                v-on:load="stopShimmer()"
                              />
                            </figure>
                            <figure
                              class="cursor-pointer"
                              v-if="resource1.CoverImageURL"
                            >
                              <div class="shimmer-effect">
                                <photo class="shine"></photo>
                              </div>
                              <div class="resource-pin">
                                <span
                                  ><img src="../assets/Player/images/unpin.svg"
                                /></span>
                              </div>
                              <img
                                alt="Detail1"
                                :src="resource1.CoverImageURL"
                                v-on:load="stopShimmer()"
                              />
                            </figure>

                            <figure
                              class="cursor-pointer"
                              v-if="resource1.ResourceType == 'image'"
                            >
                              <div class="shimmer-effect">
                                <photo class="shine"></photo>
                              </div>
                              <div class="resource-pin">
                                <span
                                  ><img src="../assets/Player/images/unpin.svg"
                                /></span>
                              </div>
                              <img
                                alt="Detail1"
                                :src="resource1.ResourcePath"
                                v-on:load="stopShimmer()"
                              />
                            </figure>
                            <div
                              class="re-content px-3 cursor-pointer"
                              v-if="resource1.ResourceType == 'hyperLink'"
                            >
                              <p>
                                {{ resource1.ResourceName }}
                                <img
                                  src="../assets/Images/icons/open-in-new-tab.svg"
                                  class="new-tab-ico"
                                  height="15px"
                                />
                              </p>
                            </div>
                            <div class="re-content px-3 cursor-pointer" v-else>
                              <p>{{ resource1.ResourceName }}</p>
                            </div>
                            <div class="re-event-date-hld px-3">
                              {{ resource1.Description }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <template slot="prev"
                        ><span class="prev">prev</span></template
                      >

                      <template
                        slot="next"
                        v-if="filteredResourcePinList.length > 3"
                        ><span class="next">next</span></template
                      >
                    </carousel>
                  </div>
                </div>
              </div>
              <div class="resources-filter-body">
                <div class="row">
                  <div class="col-md-12">
                    <div class="masonry-grid">
                      <div
                        class="masonry-grid-item"
                        v-for="resource in filteredResourceList"
                        v-bind:key="resource.Id"
                      >
                        <div
                          v-if="resource.IsPinned == false"
                          v-on:click="openResourceModal(resource)"
                          :data-tag="
                            'resources/' +
                            'viewed' +
                            '/' +
                            resource.ResourceName
                          "
                          @click="onClickHandler"
                          class="re-wrapperd-flex resource-image flex-column"
                        >
                          <figure
                            class="cursor-pointer"
                            v-if="
                              resource.ResourceType == 'video' &&
                              (resource.CoverImageURL == null ||
                                resource.CoverImageURL == '')
                            "
                          >
                            <div class="shimmer-effect">
                              <photo class="shine"></photo>
                            </div>

                            <div
                              class="resource-pin"
                              v-if="resource.IsPinned == true"
                            >
                              <span
                                ><img src="../assets/Player/images/unpin.svg"
                              /></span>
                            </div>
                            <img
                              alt="Detail1"
                              src="../assets/Images/video-temp.jpg"
                              v-on:load="stopShimmer()"
                            />
                          </figure>
                          <figure
                            class="cursor-pointer"
                            v-if="
                              resource.ResourceType == 'pdf' &&
                              resource.CoverImageURL == ''
                            "
                          >
                            <div class="shimmer-effect">
                              <photo class="shine"></photo>
                            </div>

                            <div
                              class="resource-pin"
                              v-if="resource.IsPinned == true"
                            >
                              <span
                                ><img src="../assets/Player/images/unpin.svg"
                              /></span>
                            </div>
                            <img
                              alt="Detail1"
                              src="../assets/Images/pdf-file.jpg"
                              v-on:load="stopShimmer()"
                            />
                          </figure>
                          <figure
                            class="cursor-pointer"
                            v-if="resource.CoverImageURL"
                          >
                            <div class="shimmer-effect">
                              <photo class="shine"></photo>
                            </div>
                            <div
                              class="resource-pin"
                              v-if="resource.IsPinned == true"
                            >
                              <span
                                ><img src="../assets/Player/images/unpin.svg"
                              /></span>
                            </div>
                            <img
                              alt="Detail1"
                              :src="getCDNUrl(resource.CoverImageURL)"
                              v-on:load="stopShimmer()"
                            />
                          </figure>

                          <figure
                            class="cursor-pointer"
                            v-if="resource.ResourceType == 'image'"
                          >
                            <div class="shimmer-effect">
                              <photo class="shine"></photo>
                            </div>
                            <div
                              class="resource-pin"
                              v-if="resource.IsPinned == true"
                            >
                              <span
                                ><img src="../assets/Player/images/unpin.svg"
                              /></span>
                            </div>
                            <img
                              alt="Detail1"
                              :src="getCDNUrl(resource.ResourcePath)"
                              v-on:load="stopShimmer()"
                            />
                          </figure>

                          <figure
                            class="cursor-pointer"
                            v-if="resource.ResourceType == 'code'"
                          >
                            <div class="shimmer-effect">
                              <photo class="shine"></photo>
                            </div>
                            <div
                              class="resource-pin"
                              v-if="resource.IsPinned == true"
                            >
                              <span
                                ><img src="../assets/Player/images/unpin.svg"
                              /></span>
                            </div>
                            <div
                              style="overflow-x: auto"
                              v-html="getCDNUrl(resource.EmbedCode)"
                              v-on:load="stopShimmer()"
                            ></div>
                          </figure>

                          <!-- <figure
                            v-else-if="
                              resource.ResourcePath != null &&
                              resource.CoverImageURL == null
                            "
                          >
                            <img alt="Detail2" :src="resource.ResourcePath" />
                          </figure> -->
                          <div
                            style="display: inline-flex"
                            class="re-content px-3 cursor-pointer"
                            v-if="resource.ResourceType == 'hyperLink'"
                          >
                            <p>
                              {{ resource.ResourceName }}
                              <img
                                src="../assets/Images/icons/open-in-new-tab.svg"
                                height="15px"
                              />
                              <v-tooltip v-if="!resource.isBookmarked" bottom>
                                <template v-slot:activator="{ on }">
                                  <v-icon
                                    size="32"
                                    color="black"
                                    @click.stop="addBookMark(resource)"
                                    style="cursor: pointer"
                                    v-on="on"
                                    >bookmark_border</v-icon
                                  >
                                </template>
                                <span>Bookmark</span>
                              </v-tooltip>
                              <v-tooltip v-else bottom>
                                <template v-slot:activator="{ on }">
                                  <v-icon
                                    size="32"
                                    color="success"
                                    @click.stop="addBookMark(resource)"
                                    style="cursor: pointer"
                                    v-on="on"
                                    >bookmark</v-icon
                                  >
                                </template>
                                <span>Bookmarked</span>
                              </v-tooltip>
                            </p>
                          </div>
                          <div
                            style="display: inline-flex"
                            class="re-content px-3 cursor-pointer"
                            v-else
                          >
                            <p>{{ resource.ResourceName }}</p>
                            <v-tooltip v-if="!resource.isBookmarked" bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  size="32"
                                  color="black"
                                  @click.stop="addBookMark(resource)"
                                  style="cursor: pointer"
                                  v-on="on"
                                  >bookmark_border</v-icon
                                >
                              </template>
                              <span>Bookmark</span>
                            </v-tooltip>
                            <v-tooltip v-else bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  size="32"
                                  color="success"
                                  @click.stop="addBookMark(resource)"
                                  style="cursor: pointer"
                                  v-on="on"
                                  >bookmark</v-icon
                                >
                              </template>
                              <span>Bookmarked</span>
                            </v-tooltip>
                          </div>
                          <div class="re-event-date-hld px-3">
                            {{ resource.Description }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="attendeeMod modal fade"
        id="resource-modal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div
          role="document"
          v-bind:class="
            resourceType == 'pdf'
              ? 'modal-dialog modal-lg'
              : 'modal-dialog modal'
          "
        >
          <div class="modal-content">
            <div class="modal-body">
              <b>{{ resourceName }}</b>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                v-on:click="resetResourceOnClose()"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18.03"
                  height="18.031"
                  viewBox="0 0 18.03 18.031"
                >
                  <path
                    id="close.svg"
                    fill="#242432"
                    d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                    transform="translate(-1412 -516)"
                  />
                </svg>
              </button>
              <div class="resource-modal-inner">
                <div
                  class="file-freame position-relative"
                  v-if="iframeFlg == false && imgFlg == false"
                >
                  <iframe
                    id="resource-viwer"
                    :src="resourceContent"
                    allowfullscreen
                  ></iframe>
                  <a
                    v-if="isFilePDF == true"
                    :href="resourceContent"
                    target="_blank"
                  >
                    <div class="new-tab">
                      <i class="fa fa-external-link" aria-hidden="true"></i>
                    </div>
                  </a>
                </div>
                <div
                  class="file-freame"
                  v-else-if="iframeFlg == false && imgFlg == true"
                >
                  <img :src="resourceContent" />
                </div>
                <div
                  class="file-freame remove-frame-value"
                  v-else
                  v-html="resourceContent"
                ></div>

                <div
                  class="frame-buttons justify-content-center"
                  v-if="iframeFlg == false && resourceType == 'pdf'"
                >
                  <button
                    class="download-resource pr-5 pl-5"
                    v-on:click="downloadResourceFile(resourceContent)"
                    :data-tag="
                      'resources/' + 'downloadFile' + '/' + resourceName
                    "
                    @click="onClickHandler"
                  >
                    {{ $t("resource.download") }}
                  </button>
                  <!-- <button class="bookmark-file">Add to Briefcase</button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="divLoading"
        style="
          margin: 0px;
          padding: 0px;
          position: fixed;
          right: 0px;
          top: 0px;
          width: 100%;
          height: 100%;
          z-index: 30001;
          opacity: 1;
          transform: scale(2);
          display: none;
        "
      >
        <!-- <p style="position: fixed; top: 45%; left: 45%;"> -->
        <div class="loader">
          <!-- <div class="item-c item-1"></div>
        <div class="item-c item-2"></div>
        <div class="item-c item-3"></div>
            <div class="item-c item-4"></div>-->
          <svg
            width="65px"
            height="65px"
            viewBox="0 0 66 66"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <animateTransform
                attributeName="transform"
                type="rotate"
                values="0 33 33;270 33 33"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <circle
                fill="none"
                stroke-width="6"
                stroke-linecap="round"
                cx="33"
                cy="33"
                r="30"
                stroke-dasharray="187"
                stroke-dashoffset="610"
              >
                <animate
                  attributeName="stroke"
                  values="#4285F4;#DE3E35;#F7C223;#1B9A59;#4285F4"
                  begin="0s"
                  dur="5.6s"
                  fill="freeze"
                  repeatCount="indefinite"
                />
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  values="0 33 33;135 33 33;450 33 33"
                  begin="0s"
                  dur="1.4s"
                  fill="freeze"
                  repeatCount="indefinite"
                />
                <animate
                  attributeName="stroke-dashoffset"
                  values="187;46.75;187"
                  begin="0s"
                  dur="1.4s"
                  fill="freeze"
                  repeatCount="indefinite"
                />
              </circle>
            </g>
          </svg>
        </div>
        <!-- </p> -->
      </div>
    </section>
  </div>
</template>
<script>
import jQuery from "jquery";
let $ = jQuery;
import analytics from "@/components/Analytics";
import db from "../components/firebaseInit";
import axios from "axios";
import APIs from "@/components/APIInit";
import carousel from "vue-owl-carousel";
export default {
  components: { carousel },
  data() {
    return {
      APIs: APIs,
      headerText: this.$t("resource.resource"),
      resourceList: [],
      categoryList: [],
      resourceTypeList: [],
      leftPanFlg: false,
      resourceContent: null,
      resourceName: null,
      fileName: null,
      iframeFlg: false,
      searchVal: "",
      filterByCategory: "",
      filterByType: "",
      imgFlg: false,
      resourceType: null,
      hideFilters: true,
      hiddenCategory: [],
      categorySearchName: null,
      resourcePinnedList: [],
      isFilePDF: false,
      notMappedCategories: [],
    };
  },
  methods: {
    addBookMark(bookmarkItem) {
      console.log(bookmarkItem);

      let rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
        },
        data: {
          eventName: this.$store.state.eventname,
          enetityUserId: this.$store.state.userId,
          attendeeId: this.$store.state.userId,
          entityType: 6,
          entityName: bookmarkItem.ResourceName,
          entityImage: bookmarkItem.CoverImageURL,
          entityId: bookmarkItem.Id,
          entityLink: this.$route.path,
          entityMetadata: bookmarkItem,
        },
      };
      if (bookmarkItem.isBookmarked) {
        bookmarkItem.isBookmarked = false;
        axios({
          method: "post",
          url: this.APIs.BookmarkAPIConfig.Delete,
          data: rqstData,
        })
          .then(() => {
            bookmarkItem.isBookmarked = false;
          })
          .catch(() => {
            bookmarkItem.isBookmarked = true;
          });
      } else {
        bookmarkItem.isBookmarked = true;
        axios({
          method: "post",
          url: this.APIs.BookmarkAPIConfig.Create,
          data: rqstData,
        })
          .then(() => {
            bookmarkItem.isBookmarked = true;
          })
          .catch(() => {
            bookmarkItem.isBookmarked = false;
          });
      }
    },
    exitmenu: function () {
      $(".tab-content-one .tab-pane").removeClass("active");
      $(".nav-link.tab-link").removeClass("active");
    },
    onClickHandler(event) {
      // event.target is the clicked element object
      debugger;
      this.AddAnalitics(event, "click");
    },
    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");
            console.log("actionLabel=====", actionLabel);

            if (actionLabel !== "") {
              this.event_collectionName = obj.eventcollectionname;
              analytics.AddUserAction(
                this.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          this.event_collectionName = obj.eventcollectionname;
          analytics.AddUserAction(
            this.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },
    fetchCategories() {
      this.categoryList.push({
        Id: "1",
        Name: "All",
      });
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var listRef = db
        .collection(obj.eventcollectionname)
        .doc("Resources")
        .collection("Categories");
      listRef
        .orderBy("CreatedTime", "desc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (
              doc.data().IsHidden == false ||
              doc.data().IsHidden == undefined
            ) {
              // if(doc.data().Name != 'News Letters' && doc.data().Name != 'Client Development' && doc.data().Name != 'CX: RELATED BOOKS' && doc.data().Name != 'Banking & Finance')
              this.categoryList.push(doc.data());
            } else {
              if (
                this.$route.query.cat != undefined &&
                parseInt(doc.data().Id) == this.$route.query.cat
              ) {
                this.categorySearchName = doc.data().Name;
                this.hiddenCategory.push(doc.data().Name);
              } else {
                if (doc.data().IsHidden == true) {
                  this.categorySearchName = doc.data().Name;
                  this.hiddenCategory.push(doc.data().Name);
                }
              }
            }
          });
          if (
            this.$route.query.cat != null &&
            this.categorySearchName != null
          ) {
            this.filterByCategory = this.categorySearchName;
            this.hideFilters = false;
            document.getElementById("headerText").innerText =
              this.categorySearchName;
          } else {
            this.filterByCategory = "";
          }

          this.categoryList.sort(function (a, b) {
            let aName = a.Name.trim().toLowerCase();
            let bName = b.Name.trim().toLowerCase();
            if (aName < bName) {
              return -1;
            }
            if (aName > bName) {
              return 1;
            }
            return 0;
          });
        });
    },
    updateTypeDisplayName(name) {
      if (name == "pdf") {
        return "PDF";
      } else if (name == "video") {
        return "Video";
      } else if (name == "image") {
        return "Image";
      } else if (name == "hyperLink") {
        return "URL";
      } else if (name == "code") {
        return "Embed Code";
      }
    },
    //     fetchResources() {
    //   this.resourceTypeList.push({
    //     Id: "99999",
    //     Name: "All",
    //     DisplayName: "All",
    //   });
    //   var obj = JSON.parse(window.localStorage.getItem("my-app"));
    //   var listRef = db
    //     .collection(obj.eventcollectionname) //"OA_UAT_C1591205467009E1591206650065")
    //     .doc("Resources")
    //     .collection("resourceList");
    //   listRef
    //     .orderBy("IsPinned", "desc")
    //     .orderBy("CreatedTime", "desc")
    //     .where("IsPublished", "==", true)
    //     .get()
    //     .then((querySnapshot) => {
    //       querySnapshot.forEach((doc) => {
    //         this.notMappedCategories.push("1");
    //         this.notMappedCategories.push(doc.data().SelectedCategory[0].Id);
    //         if (
    //           this.hiddenCategory.includes(
    //             doc.data().SelectedCategory[0].Name
    //           ) == false
    //         ) {
    //           if (doc.data().IsPinned == false) {
    //             this.resourceList.push(doc.data());
    //             this.resourceTypeList.push({
    //               Id: doc.data().Id,
    //               Name: doc.data().ResourceType,
    //               DisplayName: this.updateTypeDisplayName(
    //                 doc.data().ResourceType
    //               ),
    //             });
    //           } else {
    //             this.resourcePinnedList.push(doc.data());
    //           }
    //         } else {
    //           if (this.hideFilters == false) {
    //             if (doc.data().IsPinned == false) {
    //               this.resourceList.push(doc.data());
    //               this.resourceTypeList.push({
    //                 Id: doc.data().Id,
    //                 Name: doc.data().ResourceType,
    //                 DisplayName: this.updateTypeDisplayName(
    //                   doc.data().ResourceType
    //                 ),
    //               });
    //             } else {
    //               this.resourcePinnedList.push(doc.data());
    //             }
    //           }
    //         }
    //       });
    //       this.resourceTypeList = this.resourceTypeList.filter(
    //         (type, index, self) =>
    //           index === self.findIndex((t) => t.Name === type.Name)
    //       );
    //       this.resourceTypeList.sort(function (a, b) {
    //         let aName = a.DisplayName.trim().toLowerCase();
    //         let bName = b.DisplayName.trim().toLowerCase();
    //         if (aName < bName) {
    //           return -1;
    //         }
    //         if (aName > bName) {
    //           return 1;
    //         }
    //         return 0;
    //       });
    //     });
    // },
    fetchResources() {
      this.resourceTypeList.push({
        Id: "99999",
        Name: "All",
        DisplayName: "All",
      });
      let self = this;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var listRef = db
        .collection(obj.eventcollectionname) //"OA_UAT_C1591205467009E1591206650065")
        .doc("Resources")
        .collection("resourceList");
      listRef
        .orderBy("IsPinned", "desc")
        .orderBy("CreatedTime", "desc")
        .where("IsPublished", "==", true)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let data = doc.data();

            this.notMappedCategories.push("1");
            this.notMappedCategories.push(data.SelectedCategory[0].Id);
            if (
              this.hiddenCategory.includes(data.SelectedCategory[0].Name) ==
              false
            ) {
              if (data.IsPinned == false) {
                data.isBookmarked = false;
                // try {
                //   let bookmarkExists = axios({
                //     method: "post",
                //     url: self.APIs.BookmarkAPIConfig.Get,
                //     data: rqstData,
                //   });
                //   if (bookmarkExists.data && bookmarkExists.data.isPublished)
                //     data.isBookmarked = true;
                //   else data.isBookmarked = false;
                // } catch (e) {
                //   console.log(e);
                //   data.isBookmarked = false;
                // }

                // try {
                //   let bookmarkExists = axios({
                //     method: "post",
                //     url: self.APIs.BookmarkAPIConfig.Get,
                //     data: rqstData,
                //   });
                //   if (bookmarkExists.data && bookmarkExists.data.isPublished)
                //     data.isBookmarked = true;
                //   else data.isBookmarked = false;
                // } catch (e) {
                //   console.log(e);
                //   data.isBookmarked = false;
                // }
                this.resourceList.push(data);
                this.resourceTypeList.push({
                  Id: data.Id,
                  Name: data.ResourceType,
                  DisplayName: this.updateTypeDisplayName(data.ResourceType),
                });
              } else {
                this.resourcePinnedList.push(data);
              }
            } else {
              if (this.hideFilters == false) {
                if (data.IsPinned == false) {
                  data.isBookmarked = false;
                  this.resourceList.push(data);
                  this.resourceTypeList.push({
                    Id: data.Id,
                    Name: data.ResourceType,
                    DisplayName: this.updateTypeDisplayName(data.ResourceType),
                  });
                } else {
                  this.resourcePinnedList.push(data);
                }
              }
            }
          });

          this.resourceList.map((resource) => {
            let rqstData = {
              key: {
                instanceId: "OA_UAT",
                clientId: self.$store.state.client[0].id,
                eventId: self.$store.state.eventid,
              },
              data: {
                eventName: self.$store.state.eventname,
                enetityUserId: self.$store.state.userId,
                attendeeId: self.$store.state.userId,
                entityId: resource.Id,
              },
            };

            axios({
              method: "post",
              url: self.APIs.BookmarkAPIConfig.Get,
              data: rqstData,
            })
              .then((response) => {
                if (response.data && response.data.isPublished) {
                  resource.isBookmarked = true;
                  this.resourceTypeList = this.resourceTypeList.filter(
                    (type, index, self) =>
                      index === self.findIndex((t) => t.Name === type.Name)
                  );
                } else {
                  resource.isBookmarked = false;
                  this.resourceTypeList = this.resourceTypeList.filter(
                    (type, index, self) =>
                      index === self.findIndex((t) => t.Name === type.Name)
                  );
                }
              })
              .catch(() => console.log("error occured"));
          });

          this.resourceTypeList = this.resourceTypeList.filter(
            (type, index, self) =>
              index === self.findIndex((t) => t.Name === type.Name)
          );
          this.resourceTypeList.sort(function (a, b) {
            let aName = a.DisplayName.trim().toLowerCase();
            let bName = b.DisplayName.trim().toLowerCase();
            if (aName < bName) {
              return -1;
            }
            if (aName > bName) {
              return 1;
            }
            return 0;
          });
        });
    },
    leftPanelOpen() {
      $(".sidebar").toggleClass("active");
    },
    openResourceModal(data) {
      this.resourceName = null;
      this.fileName = null;
      //this.resourceContent = null;
      if (data.ResourceType == "video") {
        this.resourceType = data.ResourceType;
        if (data.ResourcePath.includes("iframe") == true) {
          this.iframeFlg = true;
        } else {
          this.iframeFlg = false;
        }
        this.resourceContent = data.ResourcePath;
        this.resourceName = data.ResourceName;
        this.imgFlg = false;
        this.fileName = data.FileName;
        this.isFilePDF = false;
        $("#resource-modal").modal("show");
      } else if (data.ResourceType == "pdf") {
        this.resourceType = data.ResourceType;
        this.iframeFlg = false;
        this.imgFlg = false;
        this.resourceContent = data.ResourcePath;
        this.resourceName = data.ResourceName;
        this.fileName = data.FileName;
        this.isFilePDF = true;
        $("#resource-modal").modal("show");
      } else if (data.ResourceType == "image") {
        this.resourceType = data.ResourceType;
        this.iframeFlg = false;
        this.imgFlg = true;
        this.resourceContent = data.ResourcePath;
        this.resourceName = data.ResourceName;
        this.fileName = data.FileName;
        this.isFilePDF = false;
        $("#resource-modal").modal("show");
      } else if (data.ResourceType == "code") {
        this.resourceType = data.ResourceType;
        this.iframeFlg = false;
        this.imgFlg = false;
        this.resourceName = null;
        this.fileName = null;
        this.isFilePDF = false;
      } else if (data.ResourceType == "hyperLink") {
        this.resourceType = data.ResourceType;
        this.iframeFlg = false;
        this.imgFlg = false;
        this.resourceName = null;
        this.fileName = null;
        this.isFilePDF = false;
        var url = data.HyperLinkUrl;
        window.open(url, "_blank");
      }
    },
    showLoader: function () {
      if ($("#divLoading") != null) {
        $("#divLoading").show();
      }
    },

    hideLoader: function () {
      //if (timerLoader != null) {
      clearTimeout(this.timerLoader);
      // alert("outside");
      if ($("#divLoading") != null) {
        //alert("inside");
        $("#divLoading").hide();
      }
      //}
    },
    downloadResourceFile(url) {
      this.showLoader();
      axios({
        method: "get",
        url: url,
        responseType: "arraybuffer",
      })
        .then((response) => {
          this.forceFileDownload(response);
        })
        .catch(() => console.log("error occured"));
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", this.fileName); //or any other extension
      document.body.appendChild(link);
      link.click();
      this.hideLoader();
    },
    resetResourceOnClose() {
      this.resourceContent = null;
    },
    stopShimmer() {
      $(".shimmer-effect").css("display", "none");
    },
    mob_reslist_search() {
      $("#mob_res_search").css("display", "flex");
      $(".mob_search_button").css("opacity", "0 ");
    },
    mob_resFilter() {
      $(".resource_page_main .sidebar").addClass("active");
    },
  },
  computed: {
    filteredResourceList() {
      return this.resourceList.filter((resource) => {
        console.log(resource.Id);
        if (this.searchVal != "") {
          return resource.ResourceName.toLowerCase().includes(
            this.searchVal.toLowerCase()
          );
        } else if (this.filterByCategory != "" && this.filterByType == "") {
          if (this.filterByCategory == "All") {
            return resource;
          } else {
            return resource.SelectedCategory[0].Name.toLowerCase().includes(
              this.filterByCategory.toLowerCase()
            );
          }
        } else if (this.filterByType != "" && this.filterByCategory == "") {
          if (this.filterByType == "All") {
            return resource;
          } else {
            return resource.ResourceType.toLowerCase().includes(
              this.filterByType.toLowerCase()
            );
          }
        } else if (this.filterByType != "" && this.filterByCategory != "") {
          if (this.filterByType == "All" && this.filterByCategory != "All") {
            return resource.SelectedCategory[0].Name.toLowerCase().includes(
              this.filterByCategory.toLowerCase()
            );
          } else if (
            this.filterByCategory == "All" &&
            this.filterByType != "All"
          ) {
            return resource.ResourceType.toLowerCase().includes(
              this.filterByType.toLowerCase()
            );
          } else if (
            this.filterByCategory == "All" &&
            this.filterByType == "All"
          ) {
            return resource;
          } else {
            return (
              resource.SelectedCategory[0].Name.toLowerCase().includes(
                this.filterByCategory.toLowerCase()
              ) &&
              resource.ResourceType.toLowerCase().includes(
                this.filterByType.toLowerCase()
              )
            );
          }
        } else {
          return resource;
        }
      });
    },
    //     filteredResourceList() {
    //   return this.resourceList.filter((resource) => {
    //     if (this.searchVal != "") {
    //       return resource.ResourceName.toLowerCase().includes(
    //         this.searchVal.toLowerCase()
    //       );
    //     } else if (this.filterByCategory != "" && this.filterByType == "") {
    //       if (this.filterByCategory == "All") {
    //         return resource;
    //       } else {
    //         return resource.SelectedCategory[0].Name.toLowerCase().includes(
    //           this.filterByCategory.toLowerCase()
    //         );
    //       }
    //     } else if (this.filterByType != "" && this.filterByCategory == "") {
    //       if (this.filterByType == "All") {
    //         return resource;
    //       } else {
    //         return resource.ResourceType.toLowerCase().includes(
    //           this.filterByType.toLowerCase()
    //         );
    //       }
    //     } else if (this.filterByType != "" && this.filterByCategory != "") {
    //       if (this.filterByType == "All" && this.filterByCategory != "All") {
    //         return resource.SelectedCategory[0].Name.toLowerCase().includes(
    //           this.filterByCategory.toLowerCase()
    //         );
    //       } else if (
    //         this.filterByCategory == "All" &&
    //         this.filterByType != "All"
    //       ) {
    //         return resource.ResourceType.toLowerCase().includes(
    //           this.filterByType.toLowerCase()
    //         );
    //       } else if (
    //         this.filterByCategory == "All" &&
    //         this.filterByType == "All"
    //       ) {
    //         return resource;
    //       } else {
    //         return (
    //           resource.SelectedCategory[0].Name.toLowerCase().includes(
    //             this.filterByCategory.toLowerCase()
    //           ) &&
    //           resource.ResourceType.toLowerCase().includes(
    //             this.filterByType.toLowerCase()
    //           )
    //         );
    //       }
    //     } else {
    //       return resource;
    //     }
    //   });
    // },
    filteredResourcePinList() {
      return this.resourcePinnedList.filter((resource) => {
        if (this.searchVal != "") {
          return resource.ResourceName.toLowerCase().includes(
            this.searchVal.toLowerCase()
          );
        } else if (this.filterByCategory != "" && this.filterByType == "") {
          if (this.filterByCategory == "All") {
            return resource;
          } else {
            return resource.SelectedCategory[0].Name.toLowerCase().includes(
              this.filterByCategory.toLowerCase()
            );
          }
        } else if (this.filterByType != "" && this.filterByCategory == "") {
          if (this.filterByType == "All") {
            return resource;
          } else {
            return resource.ResourceType.toLowerCase().includes(
              this.filterByType.toLowerCase()
            );
          }
        } else if (this.filterByType != "" && this.filterByCategory != "") {
          if (this.filterByType == "All" && this.filterByCategory != "All") {
            return resource.SelectedCategory[0].Name.toLowerCase().includes(
              this.filterByCategory.toLowerCase()
            );
          } else if (
            this.filterByCategory == "All" &&
            this.filterByType != "All"
          ) {
            return resource.ResourceType.toLowerCase().includes(
              this.filterByType.toLowerCase()
            );
          } else if (
            this.filterByCategory == "All" &&
            this.filterByType == "All"
          ) {
            return resource;
          } else {
            return (
              resource.SelectedCategory[0].Name.toLowerCase().includes(
                this.filterByCategory.toLowerCase()
              ) &&
              resource.ResourceType.toLowerCase().includes(
                this.filterByType.toLowerCase()
              )
            );
          }
        } else {
          return resource;
        }
      });
    },
  },
  async mounted() {
    // $(".sidebar").toggleClass("active");
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    if (obj.EventFont != undefined) {
      if (obj.EventFont.length > 0) {
        debugger;
        var urlpath = "";
        if (obj.EventFont[0].FontPath != "") {
          if (obj.EventFont[0].FontFamily != "") {
            urlpath = obj.EventFont[0].FontPath;

            var newStyle = document.createElement("style");
            newStyle.appendChild(
              document.createTextNode(
                "\
@font-face {\
    font-family: " +
                  obj.EventFont[0].FontFamily +
                  ";\
    src:" +
                  urlpath +
                  " ;\
}\
"
              )
            );

            document.head.appendChild(newStyle);

            $(
              "<style>* { font-family: '" +
                obj.EventFont[0].FontFamily +
                "' !important }</style>"
            ).appendTo("head");
          }
        } else {
          $("<style>* { font-family: 'Roboto' !important }</style>").appendTo(
            "head"
          );
        }
      }
    }
    db.collection(obj.eventcollectionname)
      .doc("Menu")
      .get()
      .then((doc) => {
        var data = doc.data();
        $.each(data.AllMenu, function (key, value) {
          if (value.GroupID != 99) {
            if (value.Name == "Resources") {
              debugger;

              if (obj.locale == "English") {
                this.headerText = value.DisplayLabel;
              } else if (obj.locale == "German") {
                this.headerText = value.DisplayLabel_de;
              } else if (obj.locale == "French") {
                this.headerText = value.DisplayLabel_fr;
              } else if (obj.locale == "Chinese") {
                this.headerText = value.DisplayLabel_zh;
              } else if (self.$store.state.locale == "Spanish") {
                this.headerText = value.DisplayLabel_es;
              } else {
                this.headerText = value.DisplayLabel;
              }
              document.title = this.headerText + " - " + obj.eventname;
              document.getElementById("headerText").innerText = this.headerText;
            }
          }
        });
        $.each(data.LeftMenu, function (key, value) {
          if (value.GroupID != 99) {
            if (value.Name == "Resources") {
              if (obj.locale == "English") {
                this.headerText = value.DisplayLabel;
              } else if (obj.locale == "German") {
                this.headerText = value.DisplayLabel_de;
              } else if (obj.locale == "French") {
                this.headerText = value.DisplayLabel_fr;
              } else if (obj.locale == "Chinese") {
                this.headerText = value.DisplayLabel_zh;
              } else if (self.$store.state.locale == "Spanish") {
                this.headerText = value.DisplayLabel_es;
              } else {
                this.headerText = value.DisplayLabel;
              }
              debugger;
              document.title = this.headerText + " - " + obj.eventname;
              document.getElementById("headerText").innerText = this.headerText;
            }
          }
        });
      });
    //-------------------FAVICONJOB------------------------------------------------------------
    debugger;
    if (obj.branding[0].favicon != undefined) {
      if (obj.branding[0].favicon != "") {
        var link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = obj.branding[0].favicon;
        document.getElementsByTagName("head")[0].appendChild(link);
      }
    }
    //----------------------------------------------------------------------------------
    var brandingData;
    try {
      brandingData = await this.getBrandingJSONDetails(
        obj.eventcollectionname + "/Branding/Branding.json"
      );
      if (brandingData.data != undefined) {
        if (brandingData.data.EventInfo != undefined) {
          if (brandingData.data.EventInfo.BodyTextColor != undefined) {
            this.textColor = brandingData.data.EventInfo.BodyTextColor;
          } else {
            this.textColor = "black";
          }
        } else {
          this.textColor = "black";
        }
        console.log("BodyTextColor :- " + this.textColor);
        $("#headerText").css("color", this.textColor);
      }
    } catch (e) {
      console.log("Error in Branding Json Fetch--", e);
    }

    $("#btnAddUserView").click();
    $("#topmenu").show();
    $("#leftmenu").show();
    $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);
    debugger;
    $("#sectionId").css(
      "background-image",
      "url(" + obj.EventBranding[0].eventBGImage + ")"
    );

    $("#imgBanner").attr("src", obj.EventBranding[0].banner);
    this.fetchCategories();
    this.fetchResources();
  },
};
</script>
<style scoped>
.attendeeMod .modal-dialog {
  max-width: 750px;
}
.resources-left-filter-hld.custom-radios {
  position: relative;
  top: 0;
  left: 0;
  transition: all 0.4s;
}
.resources-filter-btn {
  position: relative;
  left: 0;
  top: 0;
  border: none;
  box-shadow: 0 0 1px #000;
  border-radius: 0;
  font-size: 20px;
}
.pan-left {
  left: -15px !important;
  transition: all 0.4s;
}

.resource-modal-inner {
  padding: 10px;
  width: 100%;
}
.file-freame {
  width: 100%;
  margin-bottom: 10px;
  height: calc(100vh - 130px);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.file-freame img {
  max-width: 100%;
  max-height: 100%;
}
.file-freame iframe {
  width: 100% !important;
  height: 100% !important;
}
.frame-buttons {
  padding: 10px 0 0;
  border-top: 1px solid #dfdfdf;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.frame-buttons .download-resource {
  background: #0d960d;
  color: #fff;
  border: none;
  padding: 6px 15px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 15px;
  margin-right: 10px;
}
.frame-buttons .bookmark-file {
  background: #7581f7;
  color: #fff;
  border: none;
  padding: 6px 15px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 15px;
}
.new-tab-ico {
  display: inline-block !important;
  width: auto !important;
}
.resource-custom-wrap {
  display: flex;
  align-items: stretch;
}
.pl-79 {
  padding-left: 79px !important;
}
.content-header-part {
  padding: 19px 0px 10px;
}
.sidebar {
  max-width: 280px;
  min-width: 280px;
  padding: 15px 15px;
  background-color: #ffffff;
  transition: all 0.4s;
}
.sidebar.active {
  max-width: 0;
  min-width: 0;
  visibility: hidden;
  display: none;
  padding: 0;
  transition: all 0.4s;
}
.resource-pin {
  padding: 10px 6px;
  text-align: right;
  position: absolute;
  right: 0;
  top: 0;
}
.resource-pin span {
  display: inline-flex;
  height: 30px;
  width: 30px;
  background: rgba(0, 0, 0, 0.4);
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  cursor: pointer;
}
.resource-pin span img {
  height: 18px;
  width: 18px;
}
.resource-image {
  position: relative;
}
.remove-frame-value {
  text-align: center;
  height: auto;
}
photo {
  display: block;
  width: 100%;
  height: 200px;
}
.shine {
  background: #f6f7f8;
  background-image: linear-gradient(
    to right,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-repeat: no-repeat;
  background-size: 800px 100%;
  display: inline-block;
  position: relative;

  -webkit-animation-duration: 1s;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-name: placeholderShimmer;
  -webkit-animation-timing-function: linear;
}
.new-tab {
  position: absolute;
  right: 0;
  bottom: 25px;
  right: 38px;
  color: #000000;
  display: inline-block;
  line-height: 49px;
  text-align: center;
  width: 44px;
  height: 44px;
  z-index: 30;
  border-radius: 50%;
  box-shadow: 0px 6px 20px 0px rgb(0 0 0 / 6%);
  background-color: #ffffff;
}
.new-tab .fa {
  font-size: 20px !important;
}
@-webkit-keyframes placeholderShimmer {
  0% {
    background-position: -468px 0;
  }

  100% {
    background-position: 468px 0;
  }
}
.custom-filter-right {
  scrollbar-color: #888 #333;
  scrollbar-width: thin;
}

.custom-filter-right::-webkit-scrollbar {
  width: 6px;
}

.custom-filter-right::-webkit-scrollbar-track {
  background: #333;
}

.custom-filter-right::-webkit-scrollbar-thumb {
  background: #888;
}

.custom-filter-right::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.search-check {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.search-check a {
  height: 44px;
  flex: 0 0 50px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 3px 3px 0;
  color: #fff !important;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
}
@media only screen and (max-width: 767px) {
  .container-fluid {
    padding: 0 !important;
  }
  .resources-filter-body .masonry-grid {
    column-count: 1;
  }
  .d-md-flex {
    display: flex;
    flex-wrap: nowrap !important;
  }
  .content-header-part .search-main {
    margin-left: 0 !important;
    width: 100%;
    margin-top: 10px;
  }
  .content-header-part .search-main .search-check {
    float: none !important;
  }
  .resources-filter-btn {
    display: block;
    margin-left: 0 !important;
  }
  .resources-filter-body {
    padding-left: 20px;
    padding-right: 20px;
  }
  #resource-modal button.close {
    top: 0;
  }
}
</style>

<style>
/* === Modern Resources page redesign (Visit-Red-Sea style) === */
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap");

.resource_page_main,
.resource_page_main * {
  font-family: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif;
}

.resource_page_main .page-head {
  font-family: "Poppins", sans-serif !important;
  font-weight: 600 !important;
  letter-spacing: 0.4px;
  color: #1a1a1a;
}

/* Sidebar - clean modern look */
.resource_page_main .sidebar {
  border-radius: 16px;
  background: #ffffff !important;
  border: 1px solid rgba(0, 0, 0, 0.04);
  padding: 18px !important;
}

.resource_page_main .category-wrapper .select-box h6 {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 13.5px;
  color: #1a1a1a;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.resource_page_main .category-wrapper .checkbox-hld label {
  font-family: "Poppins", sans-serif;
  font-size: 13.5px;
  color: #4a4a4a;
  font-weight: 400;
}

/* Filter button */
.resource_page_main .resources-filter-btn {
  border-radius: 10px !important;
  font-family: "Poppins", sans-serif !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  padding: 8px 18px !important;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
  color: #1a1a1a;
}

/* Apply button (mobile) */
.resource_page_main .res_btnapply {
  border-radius: 10px !important;
  font-family: "Poppins", sans-serif !important;
  font-weight: 500 !important;
  background: #1877f2;
  color: #fff;
  padding: 10px 22px;
}

/* Search container - unified pill */
.resource_page_main .search-main {
  min-width: 280px;
}

.resource_page_main .search-check {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  height: 44px;
}

.resource_page_main .search-resources-box {
  flex: 1 1 auto;
  width: 100%;
  position: relative;
}

/* Search input */
.resource_page_main .search-resources-box input.search-project {
  border-radius: 12px 0 0 12px !important;
  font-family: "Poppins", sans-serif !important;
  font-size: 14px !important;
  border: none !important;
  height: 44px;
  padding: 0 76px 0 16px;
  color: #1a1a1a;
  background: #fff;
  width: 100%;
}

.resource_page_main .search-resources-box input.search-project:focus {
  outline: none;
  box-shadow: none;
}

.resource_page_main .search-resources-box input.search-project::placeholder {
  color: #9aa0a6;
  font-size: 14px;
}

/* Clear button - only when input has value */
.resource_page_main .reset-search-btn {
  right: 8px !important;
  height: 28px !important;
  min-width: auto !important;
  padding: 0 8px;
  border-radius: 8px;
  background: #f3f5f9;
  transition: opacity 0.15s ease;
}

.resource_page_main .reset-search-btn p {
  font-family: "Poppins", sans-serif !important;
  font-size: 12px !important;
  color: #5a5a5a !important;
  font-weight: 500;
  cursor: pointer;
}

.resource_page_main
  .search-resources-box
  input.search-project:placeholder-shown
  + .reset-search-btn {
  opacity: 0;
  pointer-events: none;
}

/* Magnifier button on the right - attached, no gap */
.resource_page_main .search-check a {
  height: 44px;
  flex: 0 0 44px;
  width: 44px;
  border-radius: 0 12px 12px 0 !important;
  background: #ffffff
    url(../assets/Images/icons/search-reg.svg) no-repeat center !important;
  background-size: 18px !important;
  border: none !important;
  border-left: 1px solid #eceef2 !important;
}

/* Resource cards */
.resource_page_main .masonry-grid-item {
  border-radius: 16px !important;
  overflow: hidden !important;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06),
    0 1px 3px rgba(0, 0, 0, 0.04) !important;
  border: 1px solid rgba(0, 0, 0, 0.04);
  transition: transform 0.2s ease, box-shadow 0.2s ease !important;
}

.resource_page_main .resources-filter-body .masonry-grid-item:hover,
.resource_page_main .masonry-grid-item:hover {
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1),
    0 2px 6px rgba(0, 0, 0, 0.05) !important;
  transform: translateY(-2px);
}

.resource_page_main .resources-filter-body .resource-image figure,
.resource_page_main .masonry-grid-item figure {
  border-radius: 16px 16px 0 0 !important;
  margin-bottom: 0 !important;
  overflow: hidden;
}

.resource_page_main .masonry-grid-item .re-content p {
  font-family: "Poppins", sans-serif !important;
  font-weight: 600 !important;
  font-size: 15px !important;
  color: #1a1a1a !important;
  line-height: 1.4 !important;
  margin: 12px 0 6px !important;
}

.resource_page_main .masonry-grid-item .re-event-date-hld {
  font-family: "Poppins", sans-serif !important;
  font-size: 13px !important;
  color: #6b6b6b !important;
  line-height: 1.5 !important;
  margin-bottom: 16px !important;
}

/* Pinned carousel card image area */
.resource_page_main .sorting-carousel .masonry-grid-item {
  margin-bottom: 0 !important;
}

/* Resource modal - rounded */
#resource-modal .modal-content {
  border-radius: 16px !important;
  border: none;
  font-family: "Poppins", sans-serif;
}

#resource-modal .frame-buttons .download-resource,
#resource-modal .frame-buttons .bookmark-file {
  border-radius: 10px !important;
  font-family: "Poppins", sans-serif !important;
  font-weight: 500 !important;
  padding: 8px 18px !important;
}

/* Resource pin badge */
.resource_page_main .resource-pin span {
  border-radius: 8px !important;
  background: rgba(0, 0, 0, 0.55) !important;
}
</style>

